export default "__VITE_ASSET__cVFHgKFM__"